import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ProductsService} from '../../../services/products.service';
import {Product} from '../../../classes/product';
import {CartService} from '../../../services/cart.service';
import {CommonService} from '../../../services/common.service';
import {Inventory} from '../../../classes/inventory';
import {Cartitems2} from '../../../classes/cartitems';
import {Cityinventory} from '../../../classes/invcheck';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'single-product-details',
  templateUrl: 'product-details.component.html',
  styleUrls: ['product-details.component.css']
})
export class ProductDetailsComponent implements OnInit {
  prodid: number;
  public data: any;
  stockflag: number;
  ppinventory = [];
  data2: Cartitems2[];
  prodname: string;
  prodsku: string;
  prodprice: number;
  discount: number;
  totaldiscount: number;
  quantity: number;
  payable: number;
  tax: number;
  pid: number;
  flag = 0;
  cindex : number;
   totalitems:number;
   gdata: any;
  gjson:any;
  uid:any;
  uname:any;
  uemail:any;
  umobile: any;
  qt: number=1;
  msg: any;
  action: any;
  cityinventory:  Cityinventory[];
  status: any;
  city_id= 1;
  public loading = false;
  constructor(private route: ActivatedRoute
    , private router: Router
    , private productsService: ProductsService
    , private cartService: CartService,
    private commonService: CommonService,
    private snackbar: MatSnackBar) {
      this.commonService.setMenuFlag(1);
      const udata = this.commonService.getUserDataLocally();
      this.uid = udata.uid;
      this.uname = udata .uname;
      this.uemail = udata.uemail;
      this.umobile = udata.umobile;
    if (this.uid === undefined) {
      this.uid = this.getRandomInt();
      this.uname = this.uid + this.randomString();
      localStorage.setItem('idata', JSON.stringify({ uid: this.uid, uname: this.uname, umobile: "56565656",uemail: "guest@gmail.com" }));
    }

     this.cartService.totalcartitems.subscribe(totalcartitems => {
      this.totalitems = totalcartitems
    });
  }

  ngOnInit() {
    this.loading = true;
    this.qt = 1;
    this.route.params.subscribe(params => {
      const id = +params['id'];
      this.prodid = id;
      this.productsService.getProduct(id)
      .subscribe(
        (x) => {
          this.loading = false;
          this.data = x ;
        });
    });

    this.commonService.getInventoryDetails(this.prodid, this.city_id)
    .subscribe(
      (cityinventory: Cityinventory[]) => {
        this.cityinventory = cityinventory;
        if (this.cityinventory && this.cityinventory.length > 0) {
          if (this.cityinventory[0].totalstock === 0 || this.cityinventory[0].status === 0) {
            this.status = 0;
          }else {
            this.status = 1;
          }
        }});

    this.cartService.getUserCartItems(this.uid)
    .subscribe(
      (data2: Cartitems2[]) => {
        this.data2 = data2;
      }
      );
  }
  public addToCart() {
   this.stockflag = 0;
   this.ppinventory = [];
   this.flag = 0;
  this.refreshCart();
  }
refreshCart() {
  this.cartService.getUserCartItems(this.uid)
  .subscribe(
    (data2: Cartitems2[]) => {
      this.data2 = data2;
      this.getinvstatus();
    }
    );
}
  getinvstatus() {
      this.commonService.getInventoryDetails(this.prodid, this.city_id)
      .subscribe(
        (x) => {
          this.cityinventory = x;
            this.checkposibility();
        });
  }

checkposibility() {
  if (this.cityinventory[0].totalstock < this.qt) {
      this.ppinventory.push({'pid': this.prodid, 'qty': this.cityinventory[0].totalstock});
      this.stockflag = this.stockflag + 1;
  }else {
    this.stockflag = 0;
  }
  if (this.cityinventory[0].totalstock === 0 || this.cityinventory[0].status === 0) {
    this.status = 0;
  }
 if (this.stockflag === 0) {
   this.addcart(this.data.name, this.data.sku, this.data.price, this.data.id, this.data.splprice )
 }else {
   this.msg = 'We Have some Limited Stock For your item. So please modify your cart and try again';
   this.openSnackBar();
 }
}


  addcart(name: string, sku: string,price: number,id: number, splprice){
    this.loading = true;
    this.pid = id;  
    this.prodname= name;
    this.prodsku = sku;
    this.prodprice= price;
    if(splprice == 0) {
      this.discount = 0;
      this.totaldiscount = price;
      this.payable = price;
    }else{
      this.discount =  price - splprice;
      this.totaldiscount = splprice;
      this.payable = splprice;
    }
    
    this.checkItems(this.prodsku);
    this.tax = 0 ;
    if (this.flag === 0)
    {
      this.quantity = this.qt;
      this.payable = this.payable * this.quantity;
      this.cartService.createCart(this.pid, this.prodname, this.prodsku, this.prodprice, this.discount,
        this.totaldiscount, this.quantity, this.payable, this.tax, this.uid, this.uname)
      .subscribe(
        (data2: Cartitems2[]) => {
          this.data2 = data2;
          this.loading = false;
          this.test();
        });
    } else {
      this.quantity = this.data2[this.cindex].quantity + this.qt;
      this.payable = (this.data2[this.cindex].mrp - this.data2[this.cindex].discount)* this.quantity;
      this.cartService.updateCartIfPresent(this.data2[this.cindex].id, this.quantity,this.payable)
      .subscribe(
        (data2: Cartitems2[]) => {
          this.data2 = data2;
          this.loading = false;
          this.test();
        }
        );
    }
  }

  checkItems(sku) {
    if (this.data2.length > 0) {
      for (let i = 0; i < this.data2.length; i++) {
        if (this.data2[i].sku === this.prodsku) {
          this.flag = 1;
          this.cindex = i;
        }
      }
    } else {
      this.flag = 0;
    }
  }

   test() {
   let  total = this.totalitems + this.qt;
   this.cartService.changeTotalCartItems(total);
    this.msg = 'Item is added to your cart';
    this.openSnackBar();
   }

    getRandomInt() {
    return Math.floor(Math.random() * (20000 - 5 + 1)) + 5;
  }
  randomString() {
    var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
    var string_length = 5;
    var randomstring = '';
    for (var i = 0; i < string_length; i++) {
      var rnum = Math.floor(Math.random() * chars.length);
      randomstring += chars.substring(rnum, rnum + 1);
    }
    return randomstring;
  }
  AddMethod() {
    this.qt = this.qt + 1;
  }

   SubMethod() {
     if (this.qt > 1) {
    this.qt = this.qt - 1;
     } else {
     this.qt = 1;
     }
  }
  openSnackBar() {
    this.snackbar.open(this.msg , this.action,{
      duration: 4000,
    });
  }

}
